module.exports = __webpack_public_path__ + "static/media/Noreport1.e62f00f4.png";